export default "__VITE_ASSET__HPOO$tG1__"